import {Collection}  from 'backbone';
import Category from '../models/Category';

class Categories extends Collection.extend({
  url: '/api/categories',
  model: Category,
}) {}

export default Categories;
